/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum DeliveryProviderOption {
    DPD = 'DPD',
    EVERMILE = 'Evermile',
    ONFLEET = 'Onfleet',
    SFONFLEET = 'SFOnfleet',
    RMTRACKED24 = 'RMTracked24',
    RMTRACKED48 = 'RMTracked48',
    RMTRACKED24COLLECTION = 'RMTracked24Collection',
}
